import { OccupationType, PropertyType } from 'constants/kycTypes'
import { IKycData } from 'interfaces/i-api-kyc'
import { FormatEnumToList, CountrySpecificValues } from 'utils/helpers'
import { useTranslation } from 'react-i18next'
import { TranslationFile } from 'i18n'

export const LoanInformationForm = (data: IKycData) => {
	const { t } = useTranslation([
		TranslationFile.Translation,
		TranslationFile.Forms,
	])
	return {
		fieldSetName: t('forms:LoanInfoHeader'),
		formName: 'FirstAndTwoThirds',
		description: t('forms:LoanInfoDescription'),
		show: false,
		visible: true,
		controls: [
			// {
			// 	options: FormatEnumToList(Object.keys(PurposeOfLoan), 'dropdown'),
			// 	required: true,
			// 	controlName: 'loans.purposeOfLoan',
			// 	type: 'dropdown',
			// 	label: t('forms:PurposeOfLoan'),
			// 	value: data.loans[0].purposeOfLoan,
			// 	visible: true,
			// },
			// {
			// 	required: true,
			// 	controlName: 'loans.purposeOfLoanOther',
			// 	type: 'text',
			// 	label: t('forms:PurposeOfLoanOther'),
			// 	value: data.loans[0].purposeOfLoanOther,
			// 	visible: true,
			// 	condition: [
			// 		{
			// 			when: 'all',
			// 			action: 'show',
			// 			items: [
			// 				{
			// 					field: 'loans.purposeOfLoan',
			// 					rule: 'equal',
			// 					value: 'Other', //'Other'
			// 				},
			// 			],
			// 		},
			// 	],
			// },
			{
				options: FormatEnumToList(
					OccupationType,
					PropertyType.Occupation,
					TranslationFile.Dropdown,
				),
				required: true,
				controlName: 'occupationType',
				type: 'dropdown',
				label: t('forms:Occupation'),
				col: 12,
				value: data.employments[0].occupationType,
				visible: true,
				wcagAriaLabel: t('forms:WCAG-Label_DropDownOccupationType'),
			},
			{
				options: CountrySpecificValues('', PropertyType.Income),
				required: true,
				controlName: 'income',
				type: 'dropdown',
				label: t('forms:AnnualIncome'),
				col: 12,
				value: data.employments[0].income,
				visible: true,
				wcagAriaLabel: t('forms:WCAG-Label_DropDownAmountRange'),
			},
			// {
			// 	options: FormatEnumToList(Object.keys(BenificialOwner)),
			// 	required: true,
			// 	controlName: 'loans.benificialOwner',
			// 	type: 'dropdown',
			// 	label: t('forms:BenificialOwner'),
			// 	value: data.loans[0].benificialOwner,
			// 	visible: true,
			// },
		],
	}
}
